import React,{useState} from "react";
import "./../../assets/css/GlobalHeader/GlobalHeader.scss";
import GlobalLogo from "./components/GlobalLogo";
import GlobalSearch from "./components/GlobalSearch";
import GlobalHeaderActions from "./components/GlobalHeaderActions";
import useTitanApp from "../../hooks/useTitanApp";
import AddPatientPopUp from "../GlobalHeader/components/AddPatientPopUp";

export default function GlobalHeader() {
  const { appState } = useTitanApp();
  const { features } = appState || {};
  const { ifKanbanSearchBoxEnabled } = features || {};
  return (
    <section className="global-header-wrapper">
      <GlobalLogo />
      {ifKanbanSearchBoxEnabled && <GlobalSearch />}
      <GlobalHeaderActions />
    </section>
  );
}
